import { createFileRoute } from '@tanstack/react-router'
import { MigrationPage } from '../../../../modules/migration/migration-page'
import { SettingsShell } from '../../../../modules/settings/settings-shell'

/**
 * The migration settings surface (PLAN-09): the HubSpot→hosting.com CRM migration
 * console - run controls, per-object status, the validation report, and the
 * regression checklist. Wrapped in PLAN-10's SettingsShell for the consistent
 * two-pane settings layout. Reachable at /settings/migration.
 */
export const Route = createFileRoute('/_authed/settings/migration/')({
  component: () => (
    <SettingsShell>
      <MigrationPage />
    </SettingsShell>
  ),
})
